module.exports = __webpack_public_path__ + "static/media/construction_white_on_green_24dp.aee239b9.svg";